var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraydownloadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43343 4.82662L8.48688 11.877",
    stroke: "#C5C5C5",
    strokeWidth: 0.818695,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3336 9.38922C10.945 10.0655 10.4555 10.6307 9.88476 11.1624C9.61334 11.4152 9.36668 11.7363 9.07847 11.9621C8.97435 12.0437 8.278 12.6579 8.12735 12.6161C8.07214 12.6008 7.993 12.4193 7.96938 12.3861C7.83264 12.1938 7.6707 12.0209 7.52777 11.8333C7.26578 11.4894 6.96666 11.1861 6.70788 10.8397C6.4777 10.5315 6.19616 10.2658 5.97626 9.94848C5.88256 9.81327 5.75586 9.65247 5.59869 9.60141",
    stroke: "#C5C5C5",
    strokeWidth: 0.818695,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.69809,
    cy: 8.55172,
    r: 7.88742,
    transform: "rotate(179.566 8.69809 8.55172)",
    stroke: "#C5C5C5",
    strokeWidth: 0.956051
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraydownloadIcon);
export default __webpack_public_path__ + "static/media/graydownloadIcon.592e60d59b56b9e224df217c2276c9a8.svg";
export { ForwardRef as ReactComponent };